import { USER_SET_USERS, USER_APPLY_FILTER } from '../actions/constants';
const getDefaultState = () => {
  return {
    users: [],
    filters: {
      role: [] as string[],
      status: [] as string[],
      hideinactiveusers: true,
    },
  };
};

const defaultState = getDefaultState();

export default function (state = defaultState, action: UserManagementUserActionTypes) {
  switch (action.type) {
    case USER_SET_USERS: {
      const users = action.users;
      return {
        ...state,
        users,
      };
    }
    case USER_APPLY_FILTER: {
      const { key, filters } = action;
      const currFilters = Object.assign({}, state.filters);
      currFilters[key.toLowerCase()] = filters;
      return {
        ...state,
        filters: currFilters,
      };
    }
    default:
      return state;
  }
}

export type UserManagementFiltersType = Pick<ReturnType<typeof getDefaultState>, 'filters'>['filters'];

export type UserManagementUserActionTypes = {
  type: typeof USER_SET_USERS | typeof USER_APPLY_FILTER;
  key: keyof UserManagementFiltersType;
  filters: UserManagementFiltersType;
  users: any;
};
